import React, { useState, useEffect } from 'react';
import ReactHtmlParser from 'html-react-parser';
import { useParams } from 'react-router-dom';
import '../../i18n'
import { APIGet } from '../API/APIRequest'

import { GetADToken, RemoveADToken } from '../Utilities/TokenManager';
import { useLocation } from 'react-router-dom';

export function FormRuleHander() {
   
    const { stateId } = useParams();
    const [errors, setErrors] = useState([]);
    const userToken = GetADToken();
    
    useEffect(()=>{
        GetNextUrl(stateId);
    },[])
  

    const GetNextUrl = (stateId) => {
        APIGet({
            "controller": "form",
            "action": "getnexturl",
            "environment": null,
            "identifier": stateId,
            "headers": [{
                "key": "UserToken",
                "value": userToken.token
            }]
        }).then((response) => {
            console.log(response);
            window.location.href = response.data.nexturl;

        }).catch((error) => {
            var unexpected = [];
            unexpected.push("error.unexpected");
            setErrors(unexpected);
        })
    }


    return ( <div /> )
}

